import React from 'react';

import { ScrollContainer, ScrollContent } from './styles';

const Scroll: React.FC = ({ children }) => {
  return (
    <ScrollContainer>
      <ScrollContent>
        <>{children}</>
      </ScrollContent>
    </ScrollContainer>
  );
};

export default Scroll;
